<template>
    <div class="mt-4 mb-2">
        <v-timeline
            class="petition-timeline mx-5 covid-screening-message-card"
            style="width: 1100px"
        >
            <div v-for="message in messages">
                <v-timeline-item
                    v-if="message.direction == 'INC'"
                    color="blue lighten-2"
                    right
                >
                    <v-card class="mb-2">
                        <v-card-title class="blue lighten-2 py-1">
                            <v-icon dark size="15" class="mr-1">
                                mdi-cellphone
                            </v-icon>
                            <h2
                                class="body-1 my-0 white--text font-weight-light"
                            >
                                {{
                                    toEstTime(message.date) +
                                        " " +
                                        formatPhoneNumber(message.from)
                                }}
                            </h2>
                        </v-card-title>
                        <v-container>
                            <v-layout>
                                <v-flex xs10 class="py-0">
                                    {{ message.text }}
                                </v-flex>
                            </v-layout>
                        </v-container>
                    </v-card>
                </v-timeline-item>
                <v-timeline-item
                    v-if="message.direction == 'OUT'"
                    color="rgb(253, 180, 0)"
                    left
                >
                    <v-card class="mb-2">
                        <v-card-title
                            style="background-color: rgb(253, 180, 0)"
                            class=" py-1"
                        >
                            <v-icon dark size="15" class="mr-2">
                                mdi-laptop-windows
                            </v-icon>
                            <h2
                                class="body-1 my-0 white--text font-weight-light"
                            >
                                {{ toEstTime(message.date) + " System" }}
                            </h2>
                        </v-card-title>
                        <v-container>
                            <v-layout>
                                <v-flex xs10 class="py-0">
                                    <div>{{ message.text }}</div>
                                </v-flex>
                            </v-layout>
                        </v-container>
                    </v-card>
                </v-timeline-item>
            </div>
        </v-timeline>
    </div>
</template>
<script>
import {
    formatCurrency,
    except,
    toTitleCase,
    formatPhoneNumber,
} from "../../utils/helpers.js";
import moment from "moment";

export default {
    props: {
        row: Object,
        columns: Array,
        reloadGrid: Function,
    },
    data() {
        return {
            messages: [],
        };
    },
    async created() {
        this.loadSmsMessages();
    },
    computed: {},
    methods: {
        async loadSmsMessages() {
            const sessionID = this.row.sessionID
                ? this.row.sessionID
                : this.row.id;

            if (!sessionID) return;

            const messages = await this.$http.get(
                "api/covidScreeningSessions/getSessionMessages?sessionID=" +
                    sessionID
            );

            this.messages = messages;
        },
        formatTime(date) {
            return moment(date).format("MM/DD/YYYY h:mm:ss A");
        },
        formatDate(date) {
            if (!date) return;

            return moment(date).format("L");
        },
        toEstTime(date) {
            return moment(date).format("h:mm:ss A");
        },
        formatPhoneNumber(number) {
            return formatPhoneNumber(number.substring(1));
        },
    },
};
</script>
<style>
.petition-timeline .v-timeline-item {
    padding-bottom: 5px !important;
}
.covid-screening-message-card {
    white-space: normal !important;
}
</style>
